// extracted by mini-css-extract-plugin
module.exports = {"container":"printable_container__n0E_0","text":"printable_text__agy3u"};